import { render, staticRenderFns } from "./magazineArticle.vue?vue&type=template&id=5d37d5bc&"
import script from "./magazineArticle.vue?vue&type=script&lang=js&"
export * from "./magazineArticle.vue?vue&type=script&lang=js&"
import style0 from "./magazineArticle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports